<style lang="scss" scoped>

    .profile
    {
        width: 338px;
        margin: 0 auto;
    }

    .name
    {
        width: 100%;
        height: 90px;
        background-color: $background-blue;
        padding: 23px 0px 0px 23px;

        div:last-child
        {
            color: $font-turquoise;
        }
    }

    .text
    {
        background-color: $black30;
        line-height: 1.5;
        padding: 23px;
        div
        {
            margin-top: 10px;
            font-weight: 700;
            a
            {
                color: $font-turquoise;
            }
        }
    }

    .row > div
    {
        margin-top: 30px;
    }

</style>
<template>
    <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12">
            <div class="profile">
                <div class="portrait">
                    <img src='imgs/buzzdee.png' class="d-block" >
                </div>
                <div class="name">
                    <div class="font-lato-black-16">
                        SEBASTIAN SOMMERFELD
                    </div>
                    <div class="font-lato-medium-16">
                        LEHRER DER REALSCHULE WILDESHAUSEN
                    </div>
                </div>
                <div class="text font-lato-15">
                    "Jugendliche erfahren auf ihrem Berufsorientierungsweg durch ihre Schulen viel darüber, was ihre Stärken sind, was sie gut können und es wird ihnen die Möglichkeit gegeben, sich selbst in einem Praktikum auszuprobieren. Das deinjobfuchs.de-Projekt bringt diese Erfahrungen mit den Anforderungen der Unternehmen an ihre Mitarbeiter und Azubis zusammen und zeigt, wer mit seinen Fähigkeiten und Fertigkeiten gut zusammenpasst. Das ist in Deutschland einzigartig!"
                </div>
            </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12">
            <div class="profile">
                <div class="portrait">
                    <img src='imgs/wezzel.png' class="d-block" >
                </div>
                <div class="name">
                    <div class="font-lato-black-16">
                        MARTIN WESSEL
                    </div>
                    <div class="font-lato-medium-16">
                        LEHRER DER REALSCHULE WILDESHAUSEN
                    </div>
                </div>
                <div class="text font-lato-15">
                    "Ich bin Martin Wessel und ein echter Jobfuchs. In meiner Schulzeit ist es allen unglaublich schwer gefallen, das richtige Unternehmen oder einen Beruf zu finden, der zu uns passt. Warum? Weil wir nicht wussten, wer zu uns passt und zu wem wir passen! DeinJobFuchs hilft dir und den Unternehmen dabei, das perfekte Match zu haben. Es wird Zeit!"
                </div>
            </div>
        </div>
    </div>
</template>

<script>
	import AppLayout from "@/Layouts/App";

	export default {
		layout: AppLayout,
	};
</script>